interface LogoMarkProps {
  className?: string;
}

export function LogoMark({ className = 'h-8 w-8' }: LogoMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="182 191 285 255"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="lm-g17" x1="252.19" y1="366.29" x2="252.19" y2="307.56" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#bea051"/><stop offset="0.63" stopColor="#dcc779"/><stop offset="1" stopColor="#ead98b"/>
        </linearGradient>
        <linearGradient id="lm-g17b" x1="298.25" y1="350.67" x2="298.25" y2="282.55" href="#lm-g17"/>
        <linearGradient id="lm-g17c" x1="334.07" y1="334.35" x2="334.07" y2="257.53" href="#lm-g17"/>
        <linearGradient id="lm-g16" x1="312.1" y1="353.98" x2="358.93" y2="293.3" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2d5ea2"/><stop offset="1" stopColor="#59aad6"/>
        </linearGradient>
        <linearGradient id="lm-g16b" x1="312.31" y1="354.14" x2="359.15" y2="293.47" href="#lm-g16"/>
        <linearGradient id="lm-g16c" x1="332.38" y1="369.63" x2="379.21" y2="308.96" href="#lm-g16"/>
        <linearGradient id="lm-g16d" x1="350.67" y1="383.75" x2="397.51" y2="323.08" href="#lm-g16"/>
      </defs>
      <rect fill="#211815" x="202.1" y="210.96" width="244.96" height="215.18" rx="38.44"/>
      <path fill="url(#lm-g17)"  d="M248.47,359.9l-19.34,6.39c12.77-1.07,46.13-11.36,46.13-11.36V307.56l-26.79,7.1Z"/>
      <path fill="url(#lm-g17b)" d="M285.19,288.22v62.45a192.65,192.65,0,0,0,25.73-11.35c.89-41.52,0-56.77,0-56.77Z"/>
      <path fill="url(#lm-g17c)" d="M321.21,263v71.32s16.5-5.32,25.72-15.08V257.53Z"/>
      <path fill="url(#lm-g16)"  d="M371.06,293s6,2.49,13.84,5c-57.84,58.9-155.77,73.92-155.77,73.92,25.55.12,50-6.15,84.1-15.37s80.54-39.92,80.54-39.92L399,331l21-55.59Z"/>
      <path fill="url(#lm-g16b)" d="M286.61,369.3v4.26h24.7a67.16,67.16,0,0,0,0-11C303.37,366.82,286.61,369.3,286.61,369.3Z"/>
      <path fill="url(#lm-g16c)" d="M322,373.56h24.95V351.8s-20.1,7.8-24.95,8.51Z"/>
      <path fill="url(#lm-g16d)" d="M356.16,373H381V333.11c-8.64,8.63-24.84,15-24.84,15Z"/>
    </svg>
  );
}
